// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5369 ? "477d4af2" : chunkId) + "." + {"5223":"d5192df72e852dea","5369":"d96180db91b3d7ee"}[chunkId] + ".js";
};